import * as React from "react";

import type { DesignaliProps } from "../../types";

export const CornerLeftUp = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <polyline points="14 9 9 4 4 9" />
        <path d="M20 20h-7a4 4 0 0 1-4-4V4" />
      </svg>
    );
  },
);

export default CornerLeftUp;
